import {
  resolvePolicy,
  type PasswordPolicy,
  type PasswordPolicyTarget,
} from './passwordPolicy';

export interface PasswordPoliciesResponse {
  policies: PasswordPolicy[];
}

let cachedPolicies: PasswordPolicy[] | null = null;
let inflight: Promise<PasswordPolicy[]> | null = null;

export async function fetchPasswordPolicies(force = false): Promise<PasswordPolicy[]> {
  if (!force && cachedPolicies) {
    return cachedPolicies;
  }

  if (!force && inflight) {
    return inflight;
  }

  inflight = (async () => {
    const response = await fetch('/api/password-policies', { credentials: 'include' });
    if (!response.ok) {
      throw new Error('password_policies_fetch_failed');
    }
    const body = (await response.json()) as PasswordPoliciesResponse;
    cachedPolicies = Array.isArray(body.policies) ? body.policies : [];
    return cachedPolicies;
  })();

  try {
    return await inflight;
  } finally {
    inflight = null;
  }
}

export function clearPasswordPoliciesCache(): void {
  cachedPolicies = null;
}

export async function resolvePasswordPolicy(
  target: PasswordPolicyTarget,
  force = false,
): Promise<PasswordPolicy> {
  try {
    const policies = await fetchPasswordPolicies(force);
    return resolvePolicy(policies, target);
  } catch {
    return resolvePolicy([], target);
  }
}
